import React from 'react';
import espectacularImg from '../../assets/images/productos/EspectacularCompress.png';
import ProductsVideo from '../../assets/videos/productos.mov';

const VideoHero = () => {
  return (
    <div className="relative py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-3 gap-12 items-center">
          {/* Contenido de texto */}
          <div className="order-2 lg:order-1 lg:col-span-1">
            <h1 className="text-4xl lg:text-5xl font-black mb-6 text-gray-900 leading-tight">
              Nuestras
              <span className="block text-transparent bg-gradient-to-r from-green-500 to-emerald-500 bg-clip-text">
                Marcas
              </span>
            </h1>
            <p className="text-lg lg:text-xl mb-8 text-gray-700 leading-relaxed">
              Descubre la excelencia en cada grano. Productos mexicanos de la más alta calidad, 
              desde nuestros campos hasta tu mesa.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={() => {
                  if (window.location.pathname === '/productos') {
                    document.getElementById('productos-catalogo')?.scrollIntoView({ behavior: 'smooth' });
                  } else {
                    window.location.href = '/productos';
                  }
                }}
                className="px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-500 text-white font-bold rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
              >
                Explorar Productos
              </button>
            </div>
          </div>

          {/* Video Container */}
          <div className="order-1 lg:order-2 lg:col-span-2">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500 bg-black">
              <video
                autoPlay
                muted
                loop
                playsInline
                className="w-full h-80 lg:h-[400px] object-cover"
                poster={espectacularImg}
              >
                <source src={ProductsVideo} type="video/mp4" />
                <source src={ProductsVideo} type="video/mov" />
                Tu navegador no soporta el elemento de video.
              </video>
              
              {/* Overlay sutil */}
              <div className="absolute inset-0 bg-gradient-to-t from-green-900/30 via-transparent to-transparent"></div>
              
              {/* Indicador de reproducción */}
              <div className="absolute bottom-6 right-6 bg-white/20 backdrop-blur-sm rounded-full p-3">
                <div className="w-4 h-4 bg-white rounded-full animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoHero;
